import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = { class: "card card-body mb-0" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" }
const _hoisted_8 = { class: "col p-0" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" }
const _hoisted_11 = { class: "col p-0" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = { class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" }
const _hoisted_14 = { class: "col p-0" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_17 = { class: "col p-0" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_20 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_21 = { class: "col p-0" }
const _hoisted_22 = { class: "" }
const _hoisted_23 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_24 = { class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" }
const _hoisted_25 = { class: "col p-0" }
const _hoisted_26 = { class: "" }
const _hoisted_27 = { class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" }
const _hoisted_28 = { class: "col p-0" }
const _hoisted_29 = { class: "" }
const _hoisted_30 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_31 = { class: "col p-0" }
const _hoisted_32 = { class: "" }
const _hoisted_33 = { class: "d-flex flex-row align-items-center gap-2" }
const _hoisted_34 = {
  class: "overflow-hidden",
  style: {"white-space":"nowrap","text-overflow":"ellipsis"}
}
const _hoisted_35 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_36 = { class: "col p-0" }
const _hoisted_37 = { class: "" }
const _hoisted_38 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_39 = { class: "col p-0" }
const _hoisted_40 = { class: "" }
const _hoisted_41 = { class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" }
const _hoisted_42 = { class: "col p-0" }
const _hoisted_43 = { class: "" }
const _hoisted_44 = { class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" }
const _hoisted_45 = { class: "col p-0" }
const _hoisted_46 = { class: "" }
const _hoisted_47 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_48 = { class: "col p-0" }
const _hoisted_49 = { class: "" }
const _hoisted_50 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_51 = { class: "col p-0" }
const _hoisted_52 = { class: "" }
const _hoisted_53 = ["disabled", "placeholder"]
const _hoisted_54 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_55 = { class: "col p-0" }
const _hoisted_56 = { class: "" }
const _hoisted_57 = ["disabled", "placeholder"]
const _hoisted_58 = { class: "form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_59 = { class: "col p-0" }
const _hoisted_60 = { class: "form-check small mb-0 mt-1" }
const _hoisted_61 = {
  class: "form-check-label",
  for: "turnoverOnlyProviders"
}
const _hoisted_62 = { class: "form-group mb-2 col" }
const _hoisted_63 = { class: "col-auto p-0 text-end" }
const _hoisted_64 = { class: "row mt-3" }
const _hoisted_65 = { class: "form-group mb-2 col-auto me-2" }
const _hoisted_66 = { class: "col p-0" }
const _hoisted_67 = { class: "d-flex align-items-center flex-nowrap" }
const _hoisted_68 = { class: "me-2 mb-0" }
const _hoisted_69 = {
  class: "btn btn-sm btn-outline-dark",
  for: "turnover-group-stores"
}
const _hoisted_70 = {
  class: "btn btn-sm btn-outline-dark ms-2",
  for: "turnover-group-traders"
}
const _hoisted_71 = {
  class: "btn btn-sm btn-outline-dark ms-2",
  for: "turnover-group-providers"
}
const _hoisted_72 = { class: "form-group mb-2 col-auto" }
const _hoisted_73 = { class: "col p-0" }
const _hoisted_74 = { class: "form-check small mb-0 mt-2" }
const _hoisted_75 = {
  class: "form-check-label",
  for: "turnoverShowByFiat"
}
const _hoisted_76 = { class: "card card-body mb-0" }
const _hoisted_77 = { class: "overflow-auto" }
const _hoisted_78 = { class: "table table-bordered align-middle text-left text-nowrap position-relative" }
const _hoisted_79 = {
  colspan: "20",
  class: "text-center bg-secondary text-white"
}
const _hoisted_80 = {
  key: 0,
  class: "text-center mb-2 text-capitalize"
}
const _hoisted_81 = {
  key: 1,
  class: "text-center mb-2"
}
const _hoisted_82 = {
  key: 2,
  class: "text-center mb-2"
}
const _hoisted_83 = { key: 0 }
const _hoisted_84 = {
  key: 3,
  class: "text-center mb-2"
}
const _hoisted_85 = {
  colspan: "20",
  class: "text-center text-capitalize"
}
const _hoisted_86 = { class: "bg-light" }
const _hoisted_87 = {
  rowspan: "2",
  class: "text-capitalize-first",
  style: {"width":"0"}
}
const _hoisted_88 = {
  rowspan: "2",
  class: "text-capitalize-first text-wrap",
  style: {"width":"0"}
}
const _hoisted_89 = {
  rowspan: "2",
  class: "text-capitalize-first text-wrap",
  style: {"width":"0"}
}
const _hoisted_90 = {
  rowspan: "2",
  class: "text-capitalize-first text-wrap",
  style: {"width":"0"}
}
const _hoisted_91 = {
  rowspan: "2",
  class: "text-capitalize-first text-wrap",
  style: {"width":"0"}
}
const _hoisted_92 = {
  rowspan: "2",
  class: "text-capitalize-first text-wrap",
  style: {"width":"0"}
}
const _hoisted_93 = {
  rowspan: "2",
  class: "text-capitalize-first text-wrap",
  style: {"width":"0"}
}
const _hoisted_94 = ["colspan"]
const _hoisted_95 = { class: "bg-light" }
const _hoisted_96 = {
  class: "text-capitalize-first text-center",
  style: {"width":"0"}
}
const _hoisted_97 = {
  class: "text-capitalize-first text-center",
  style: {"width":"0"}
}
const _hoisted_98 = {
  class: "text-capitalize-first text-center",
  style: {"width":"0"}
}
const _hoisted_99 = {
  class: "text-capitalize-first text-center",
  style: {"width":"0"}
}
const _hoisted_100 = {
  class: "text-capitalize-first text-center",
  style: {"width":"0"}
}
const _hoisted_101 = { class: "text-end" }
const _hoisted_102 = { class: "text-capitalize-first text-start" }
const _hoisted_103 = { class: "text-start" }
const _hoisted_104 = { class: "text-start" }
const _hoisted_105 = {
  key: 0,
  class: "text-muted me-1"
}
const _hoisted_106 = {
  key: 1,
  class: "text-muted ms-1"
}
const _hoisted_107 = { class: "text-muted me-1" }
const _hoisted_108 = {
  key: 0,
  class: "text-muted ms-1"
}
const _hoisted_109 = {
  key: 1,
  class: "text-muted d-block"
}
const _hoisted_110 = { class: "text-muted me-1" }
const _hoisted_111 = {
  key: 0,
  class: "text-muted ms-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MerchantMultiselect = _resolveComponent("MerchantMultiselect")!
  const _component_StoreMultiselect = _resolveComponent("StoreMultiselect")!
  const _component_TrafficGroupMultiselect = _resolveComponent("TrafficGroupMultiselect")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_TraderMultiselect = _resolveComponent("TraderMultiselect")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_PayMethodIcon = _resolveComponent("PayMethodIcon")!
  const _component_DevicesMultiselect = _resolveComponent("DevicesMultiselect")!
  const _component_TeamLeadMultiselect = _resolveComponent("TeamLeadMultiselect")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_MerchantMultiselect, {
                          multiple: true,
                          modelValue: _ctx.merchantsFilter,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.merchantsFilter) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_StoreMultiselect, {
                          multiple: true,
                          modelValue: _ctx.storesFilter,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.storesFilter) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_TrafficGroupMultiselect, {
                          multiple: true,
                          small: "",
                          modelValue: _ctx.trafficGroupsFilter,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.trafficGroupsFilter) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_DatePicker, {
                          modelValue: _ctx.requestDTO.fromDate,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requestDTO.fromDate) = $event)),
                          mode: "dateTime",
                          "model-modifiers": {string: true},
                          is24hr: "",
                          masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                        }, {
                          default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                            _createElementVNode("input", {
                              class: "form-control form-control-sm",
                              placeholder: _ctx.helper.trans('labels.from_date'),
                              value: inputValue,
                              onFocus: togglePopover,
                              onChange: inputEvents.change
                            }, null, 40, _hoisted_19)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_DatePicker, {
                          modelValue: _ctx.requestDTO.toDate,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.requestDTO.toDate) = $event)),
                          mode: "dateTime",
                          "model-modifiers": {string: true},
                          is24hr: "",
                          masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                        }, {
                          default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                            _createElementVNode("input", {
                              class: "form-control form-control-sm",
                              placeholder: _ctx.helper.trans('labels.to_date'),
                              value: inputValue,
                              onFocus: togglePopover,
                              onChange: inputEvents.change
                            }, null, 40, _hoisted_23)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_TraderMultiselect, {
                          "onUpdate:modelValue": [
                            _ctx.onTraderListUpdate,
                            _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tradersFilter) = $event))
                          ],
                          multiple: true,
                          modelValue: _ctx.tradersFilter
                        }, null, 8, ["onUpdate:modelValue", "modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_Multiselect, {
                          id: "statuses",
                          class: "multiselect-sm",
                          modelValue: _ctx.requestDTO.statuses,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.requestDTO.statuses) = $event)),
                          options: Object.values(_ctx.DealStatus),
                          "custom-label": (opt) => _ctx.helper.trans(`deal_status.${opt}`),
                          multiple: true,
                          "select-label": "Select",
                          placeholder: _ctx.helper.trans('labels.statuses')
                        }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_Multiselect, {
                          id: "methods",
                          class: "multiselect-sm",
                          modelValue: _ctx.requestDTO.methods,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.requestDTO.methods) = $event)),
                          options: _ctx.store.getters['currencyMethods/methods'](),
                          "custom-label": (opt) => _ctx.helper.trans(`pay_methods.${opt}`),
                          multiple: true,
                          "select-label": "Select",
                          placeholder: _ctx.helper.trans('labels.payment_methods')
                        }, {
                          option: _withCtx((props) => [
                            _createElementVNode("div", _hoisted_33, [
                              _createVNode(_component_PayMethodIcon, {
                                "icon-class": "icon",
                                method: props.option
                              }, null, 8, ["method"]),
                              _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.helper.trans('pay_methods.' + props.option)), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options", "custom-label", "placeholder"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createVNode(_component_Multiselect, {
                          id: "options",
                          class: "multiselect-sm",
                          modelValue: _ctx.requestDTO.options,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.requestDTO.options) = $event)),
                          options: _ctx.store.getters['currencyMethods/options'](),
                          "custom-label": (opt) => _ctx.helper.trans(`payment_options.${opt}`),
                          multiple: true,
                          "select-label": "Select",
                          placeholder: _ctx.helper.trans('labels.payment_options')
                        }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _createVNode(_component_Multiselect, {
                          id: "types",
                          class: "multiselect-sm",
                          modelValue: _ctx.requestDTO.types,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.requestDTO.types) = $event)),
                          options: Object.values(_ctx.Direction),
                          "custom-label": (opt) => _ctx.helper.trans(`direction.${opt}`),
                          multiple: true,
                          "select-label": "Select",
                          placeholder: _ctx.helper.trans('labels.type')
                        }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _createVNode(_component_DevicesMultiselect, {
                          ref: "deviceMultiselect",
                          multiple: true,
                          "trader-ids": _ctx.tradersFilter.map((item) => item.id),
                          modelValue: _ctx.devicesFilter,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.devicesFilter) = $event))
                        }, null, 8, ["trader-ids", "modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createVNode(_component_TeamLeadMultiselect, {
                          multiple: false,
                          modelValue: _ctx.teamLeadFilter,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.teamLeadFilter) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _createVNode(_component_Multiselect, {
                          id: "currency",
                          class: "multiselect-sm multiselect-capitalize",
                          modelValue: _ctx.requestDTO.currency,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.requestDTO.currency) = $event)),
                          options: _ctx.store.getters['currencyMethods/currencies'],
                          "custom-label": (opt) => opt,
                          multiple: false,
                          "select-label": "Select",
                          placeholder: _ctx.helper.trans('labels.currency')
                        }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          disabled: !_ctx.requestDTO.currency,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.requestDTO.amountFrom) = $event)),
                          class: "form-control form-control-sm",
                          placeholder: _ctx.helper.trans('labels.from_sum')
                        }, null, 8, _hoisted_53), [
                          [_vModelText, _ctx.requestDTO.amountFrom]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          disabled: !_ctx.requestDTO.currency,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.requestDTO.amountTo) = $event)),
                          class: "form-control form-control-sm",
                          placeholder: _ctx.helper.trans('labels.to_sum')
                        }, null, 8, _hoisted_57), [
                          [_vModelText, _ctx.requestDTO.amountTo]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("div", _hoisted_60, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.requestDTO.onlyProviders) = $event)),
                          "true-value": "1",
                          type: "checkbox",
                          value: "",
                          id: "turnoverOnlyProviders"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.requestDTO.onlyProviders]
                        ]),
                        _createElementVNode("label", _hoisted_61, _toDisplayString(_ctx.helper.trans('labels.only_providers')), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[16] || (_cache[16] = _withModifiers(() => _ctx.applyFilters(), ["prevent"])),
                        class: "btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.apply')), 1),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[17] || (_cache[17] = _withModifiers(() => _ctx.clearFilters(), ["prevent"])),
                        class: "btn btn-outline-secondary btn-sm rounded-pill me-2 text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.reset')), 1),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[18] || (_cache[18] = _withModifiers(() => _ctx.startExport(), ["prevent"])),
                        class: "btn btn-outline-primary btn-sm rounded-pill text-capitalize-first"
                      }, [
                        _cache[23] || (_cache[23] = _createElementVNode("i", { class: "fa-solid fa-download" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('statistic.turnoverSummary.export')), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("div", _hoisted_66, [
                      _createElementVNode("div", _hoisted_67, [
                        _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.helper.trans('labels.group_by')), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.requestDTO.groupBy) = $event)),
                          value: "store",
                          class: "btn-check",
                          name: "turnover-group-by",
                          id: "turnover-group-stores",
                          autocomplete: "off",
                          checked: ""
                        }, null, 512), [
                          [_vModelRadio, _ctx.requestDTO.groupBy]
                        ]),
                        _createElementVNode("label", _hoisted_69, _toDisplayString(_ctx.helper.trans('labels.stores')), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.requestDTO.groupBy) = $event)),
                          value: "trader",
                          class: "btn-check",
                          name: "turnover-group-by",
                          id: "turnover-group-traders",
                          autocomplete: "off"
                        }, null, 512), [
                          [_vModelRadio, _ctx.requestDTO.groupBy]
                        ]),
                        _createElementVNode("label", _hoisted_70, _toDisplayString(_ctx.helper.trans('labels.traders')), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.requestDTO.groupBy) = $event)),
                          value: "provider",
                          class: "btn-check",
                          name: "turnover-group-by",
                          id: "turnover-group-providers",
                          autocomplete: "off"
                        }, null, 512), [
                          [_vModelRadio, _ctx.requestDTO.groupBy]
                        ]),
                        _createElementVNode("label", _hoisted_71, _toDisplayString(_ctx.helper.trans('labels.providers')), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("div", _hoisted_73, [
                      _createElementVNode("div", _hoisted_74, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.showByFiat) = $event)),
                          type: "checkbox",
                          id: "turnoverShowByFiat"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.showByFiat]
                        ]),
                        _createElementVNode("label", _hoisted_75, _toDisplayString(_ctx.helper.trans('statistic.turnoverSummary.byFiat')), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("div", _hoisted_77, [
                  _createElementVNode("table", _hoisted_78, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: group.groupId
                      }, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", _hoisted_79, [
                              (group.groupId === '0')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_80, _toDisplayString(_ctx.helper.trans('labels.total')), 1))
                                : (group.store)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_81, _toDisplayString(`${group.store?.merchantName} - ${group.store?.name}`), 1))
                                  : (group.trader)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_82, [
                                        _createTextVNode(_toDisplayString(group.trader?.name) + " ", 1),
                                        (group.trader?.email.length > 0)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_83, "(" + _toDisplayString(group.trader?.email) + ")", 1))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_84, "#" + _toDisplayString(group.groupId), 1))
                            ])
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.directions, (direction) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: direction }, [
                            _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", _hoisted_85, _toDisplayString(_ctx.helper.trans(`direction.${direction}`)), 1)
                              ])
                            ]),
                            _createElementVNode("thead", null, [
                              _createElementVNode("tr", _hoisted_86, [
                                _createElementVNode("th", _hoisted_87, _toDisplayString(_ctx.helper.trans('labels.metric')), 1),
                                _createElementVNode("th", _hoisted_88, _toDisplayString(_ctx.helper.trans('labels.operations_count')), 1),
                                _createElementVNode("th", _hoisted_89, _toDisplayString(_ctx.helper.trans('labels.deals_count')), 1),
                                _createElementVNode("th", _hoisted_90, _toDisplayString(_ctx.helper.trans('labels.fiat_sum')), 1),
                                _createElementVNode("th", _hoisted_91, _toDisplayString(direction === _ctx.Direction.PAY_IN ? _ctx.helper.trans('labels.trader_sum_out') : _ctx.helper.trans('labels.trader_sum_in')), 1),
                                _createElementVNode("th", _hoisted_92, _toDisplayString(direction === _ctx.Direction.PAY_IN ? _ctx.helper.trans('labels.store_sum_in') : _ctx.helper.trans('labels.store_sum_out')), 1),
                                _createElementVNode("th", _hoisted_93, _toDisplayString(_ctx.helper.trans('labels.store_fee_sum')), 1),
                                _createElementVNode("th", {
                                  colspan: _ctx.rewardColumnsCount,
                                  class: "text-center p-0"
                                }, _toDisplayString(_ctx.helper.trans('labels.rewards')), 9, _hoisted_94)
                              ]),
                              _createElementVNode("tr", _hoisted_95, [
                                _createElementVNode("th", _hoisted_96, _toDisplayString(_ctx.helper.trans('labels.trader')), 1),
                                _createElementVNode("th", _hoisted_97, _toDisplayString(_ctx.helper.trans('labels.teamlead')), 1),
                                _createElementVNode("th", _hoisted_98, _toDisplayString(_ctx.helper.trans('labels.referral')), 1),
                                _createElementVNode("th", _hoisted_99, _toDisplayString(_ctx.helper.trans('labels.service')), 1),
                                (_ctx.partners.length > 0)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partners, (partner) => {
                                        return (_openBlock(), _createElementBlock("th", {
                                          key: partner.userId,
                                          class: "text-capitalize-first text-center",
                                          style: {"width":"0"}
                                        }, _toDisplayString(partner.name), 1))
                                      }), 128)),
                                      _createElementVNode("th", _hoisted_100, _toDisplayString(_ctx.helper.trans('labels.rest_of')), 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("tbody", _hoisted_101, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.itemsByDirection[direction], (item) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: item.metric,
                                  class: _normalizeClass(_ctx.metricRowClass(item.metric))
                                }, [
                                  _createElementVNode("td", _hoisted_102, _toDisplayString(_ctx.helper.trans(`statistic.turnoverSummary.metric.${item.metric}`)), 1),
                                  _createElementVNode("td", _hoisted_103, _toDisplayString(_ctx.numberFormatter.formatNumber(item.operationsCount)), 1),
                                  _createElementVNode("td", _hoisted_104, _toDisplayString(_ctx.numberFormatter.formatNumber(item.dealsCount)), 1),
                                  _createElementVNode("td", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.fiatSums, (sum, currency) => {
                                      return (_openBlock(), _createElementBlock("div", { key: currency }, _toDisplayString(_ctx.numberFormatter.formatMoney(sum)), 1))
                                    }), 128))
                                  ]),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moneyColumns, (column) => {
                                    return (_openBlock(), _createElementBlock("td", { key: column }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cellLines(item, column), (line, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: index,
                                          class: _normalizeClass({'small text-muted': line.fiat !== null})
                                        }, [
                                          (line.fiat !== null)
                                            ? (_openBlock(), _createElementBlock("small", _hoisted_105, _toDisplayString(line.fiat), 1))
                                            : _createCommentVNode("", true),
                                          _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatMoney(line.sum, _ctx.usdtSubunits)) + " ", 1),
                                          (line.percent !== null)
                                            ? (_openBlock(), _createElementBlock("small", _hoisted_106, "(" + _toDisplayString(line.percent) + ")", 1))
                                            : _createCommentVNode("", true)
                                        ], 2))
                                      }), 128))
                                    ]))
                                  }), 128)),
                                  (_ctx.partners.length > 0)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partners, (partner) => {
                                          return (_openBlock(), _createElementBlock("td", {
                                            key: partner.userId
                                          }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((item.partnerRewardSums[partner.userId] ?? {}), (sums, takerCurrency) => {
                                              return (_openBlock(), _createElementBlock(_Fragment, { key: takerCurrency }, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sums, (sum, currency) => {
                                                  return (_openBlock(), _createElementBlock("div", { key: currency }, [
                                                    _createElementVNode("small", _hoisted_107, _toDisplayString(takerCurrency), 1),
                                                    _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatMoney(sum, _ctx.usdtSubunits)) + " ", 1),
                                                    (_ctx.formatPercent(item.partnerPercents?.[partner.userId]?.[takerCurrency]?.[currency]) !== null)
                                                      ? (_openBlock(), _createElementBlock("small", _hoisted_108, " (" + _toDisplayString(_ctx.formatPercent(item.partnerPercents?.[partner.userId]?.[takerCurrency]?.[currency])) + ") ", 1))
                                                      : _createCommentVNode("", true),
                                                    (_ctx.partnerBreakdown(item, partner.userId, takerCurrency, currency))
                                                      ? (_openBlock(), _createElementBlock("small", _hoisted_109, _toDisplayString(_ctx.partnerBreakdown(item, partner.userId, takerCurrency, currency)), 1))
                                                      : _createCommentVNode("", true)
                                                  ]))
                                                }), 128))
                                              ], 64))
                                            }), 128))
                                          ]))
                                        }), 128)),
                                        _createElementVNode("td", null, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.restSums, (sums, takerCurrency) => {
                                            return (_openBlock(), _createElementBlock(_Fragment, { key: takerCurrency }, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sums, (sum, currency) => {
                                                return (_openBlock(), _createElementBlock("div", { key: currency }, [
                                                  _createElementVNode("small", _hoisted_110, _toDisplayString(takerCurrency), 1),
                                                  _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatMoney(sum, _ctx.usdtSubunits)) + " ", 1),
                                                  (_ctx.formatPercent(item.restPercents?.[takerCurrency]?.[currency]) !== null)
                                                    ? (_openBlock(), _createElementBlock("small", _hoisted_111, " (" + _toDisplayString(_ctx.formatPercent(item.restPercents?.[takerCurrency]?.[currency])) + ") ", 1))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              }), 128))
                                            ], 64))
                                          }), 128))
                                        ])
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ], 2))
                              }), 128))
                            ])
                          ], 64))
                        }), 128)),
                        _cache[24] || (_cache[24] = _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", { colspan: "20" })
                          ])
                        ], -1))
                      ], 64))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_ConfirmModal, { ref: "confirmModal" }, null, 512)
    ]),
    _: 1
  }, 512))
}